import styled from "styled-components";
import { useTopicRelateAnswer } from "../provider/TopicRelateAnswer";
import { RelateAnswer } from "../provider/TopicRelateAnswer.type";
import {
  RELATE_ANSWER,
  RELATE_ANSWER_COLOR_OPACITY,
} from "../provider/TopicRelateAnswer.const";
import React from "react";
import RelAnswerContain from "./RelAnswerContain";
import RelateAnswerAction from "./RelateAnswerAction";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { CharacterResult } from "common/character/dto/CharacterResult";
import CharacterLetterView from "components/common/character/CharacterLetterView";
import CharacterModalLarge from "components/common/character/util/CharacterSearchSelect/CharacterModalLarge";

type RelateAnswerLetterProps = {
  letter: string;
  activeShareLetter?: string | null;
  onActivate?: () => void;
};

const RelateAnswerLetter = ({
  letter,
  activeShareLetter,
  onActivate,
}: RelateAnswerLetterProps) => {
  const { selector } = useTopicRelateAnswer();
  const containLetters = React.useMemo(
    () => selector.containByLetter(letter),
    [selector, letter]
  );
  const [activeContainLetter, setActiveContainLetter] = React.useState<
    string | null
  >(null);
  const [active, setActive] = React.useState<boolean>(false);
  const relateAnswer: RelateAnswer = selector.answerRelateTypeByLetter(letter);
  const [activeAnswer, setActiveAnswer] = React.useState<boolean>(false);
  const [letterModalShow, setLetterModalShow] = React.useState<boolean>(false);
  const character: CharacterResult | null = React.useMemo(
    () => selector.byLetter(letter),
    [letter, selector]
  );

  React.useEffect(() => {
    if (active) {
      if (onActivate) {
        onActivate();
      }
      if (relateAnswer === RELATE_ANSWER.N) {
        setActiveAnswer(true);
      }
    } else {
      setActiveContainLetter(null);
    }
  }, [active]);

  React.useEffect(() => {
    if (activeShareLetter !== letter) {
      setActive(false);
    }
  }, [activeShareLetter]);

  const letterCLickHandle = () => {
    console.log("letterCLickHandle");
    setActive(!active);
  };

  const handleClose = () => {
    setLetterModalShow(false);
  };

  const readMoreHandle = () => {
    setLetterModalShow(true);
  };

  return (
    <Div>
      <DivLetterReadNav>
        <DivLetter
          onClick={letterCLickHandle}
          relateAnswer={relateAnswer}
          active={active ?? false}
        >
          {character && <CharacterLetterView character={character} />}
          {!character && letter}
        </DivLetter>
        {active && (
          <DivReadNav>
            <ReadMoreIcon fontSize="large" onClick={readMoreHandle} />
          </DivReadNav>
        )}
      </DivLetterReadNav>
      {active && (
        <>
          {activeAnswer && relateAnswer === RELATE_ANSWER.N && (
            <RelateAnswerAction letter={letter} />
          )}
          {(!activeAnswer || relateAnswer !== RELATE_ANSWER.N) && (
            <RelAnswerContain
              letters={containLetters}
              activeLetter={activeContainLetter}
              onActivateLetter={setActiveContainLetter}
            />
          )}
        </>
      )}
      {character && (
        <CharacterModalLarge
          open={letterModalShow}
          onClose={handleClose}
          title={`Details: ${letter}`}
          character={character}
        />
      )}
    </Div>
  );
};

const Div = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 0rem;
`;

const DivLetterReadNav = styled.div`
  display: flex;
  flex-direction: row;
  gap: 2rem;
`;

const DivReadNav = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const DivLetter = styled.div<{ relateAnswer: RelateAnswer; active: boolean }>`
  display: flex;
  margin-top: 0rem;
  font-size: 3rem;
  color: ${(props) => (props.active ? "blue" : "inherit")};
  cursor: pointer;
  border-left: 0.5rem solid
    ${(props) => RELATE_ANSWER_COLOR_OPACITY[props.relateAnswer].COLOR};
  opacity: ${(props) =>
    RELATE_ANSWER_COLOR_OPACITY[props.relateAnswer].OPACITY ?? 1};
  padding-left: 1rem;
`;

export default RelateAnswerLetter;
